import { manageBadgesClick } from '@wix/bi-logger-badges/v2';

import webBiLogger from '@wix/web-bi-logger';

import Wix from '../wix-sdk-polyfill';

export const getBadgesBiLogger = () => {
  const context = {
    _msid: Wix.Utils.getInstanceValue('metaSiteId'),
    _instanceId: Wix.Utils.getInstanceValue('instanceId'),
    _siteOwnerId: Wix.Utils.getInstanceValue('siteOwnerId'),
  };

  const logger = webBiLogger
    .factory({
      trackSession: false,
    })
    .logger()
    .updateDefaults(context);

  return { manageBadgesClick: (origin: string) => logger.report(manageBadgesClick({ origin })) };
};
